import { Injectable } from '@angular/core';
import { MessageService } from './message.service';
import { HttpClient } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';

@Injectable({
    providedIn: 'root'
})
export class AdService {
    constructor(
        private messageservice: MessageService,
        private readonly http: HttpClient
    ) {}

    private log(message: string) {
        //this will become a log
        this.messageservice.add('How it works List: fetched');
    }

    getVideoLanguages() {
        return this.http
            .get<PromiseResult>('assets/data/languages.json')
            .toPromise()
            .then((res) => res.data as any[])
            .then((data) => data);
    }

    getAppLinks() {
        return this.http
            .get<PromiseResult>('assets/data/appLinks.json')
            .toPromise()
            .then((res) => res.data as any[])
            .then((data) => data);
    }
}
